// extracted by mini-css-extract-plugin
export default {"gradientFill":"JU40fT"};